/* verqo — PageSEO (Feb 2026)
   Lightweight SEO component — sets document.title + meta description +
   OpenGraph tags per sub-page. No external dependency needed.
*/
import { useEffect } from "react";

function upsertMeta(attr, value, content) {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${value}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, value);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertCanonical(href) {
  if (!href) return;
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export default function PageSEO({ title, description, ogImage, path }) {
  useEffect(() => {
    if (title) {
      document.title = title.includes("verqo") ? title : `${title} · verqo`;
    }
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    if (ogImage) upsertMeta("property", "og:image", ogImage);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    if (path) {
      const origin = typeof window !== "undefined" ? window.location.origin : "";
      upsertMeta("property", "og:url", `${origin}${path}`);
      upsertCanonical(`${origin}${path}`);
    }
  }, [title, description, ogImage, path]);
  return null;
}
